import { type DebouncedState } from "use-debounce";

import {
	type Result,
	type ResultsObserver,
	isFulfilledResult,
	isPendingResult,
} from "./interfaces";

/**
 * Watches the output of a cell (registered in the runtime as a variable), and maps it to component
 * state (i.e., state registered with `useState`).
 */
export class VariableObserver implements ResultsObserver {
	private _disposed = false;

	constructor(
		private _setBoxedValue: (result?: Result) => void,
		private _cellUpdated?: DebouncedState<(pending: unknown) => void>
	) {}

	next(result: Result) {
		if (this._disposed) {
			return;
		}

		this._setBoxedValue(result);

		if (isPendingResult(result) && result.pending) {
			this._cellUpdated?.(result.pending);
			this._cellUpdated?.flush();
		} else if (isFulfilledResult(result)) {
			this._cellUpdated?.(true);
			this._cellUpdated?.flush();
		}
	}

	dispose() {
		this._disposed = true;
	}
}
